function SectionHeading({ children, textAlignment = 'text-center', color }) {
    color = color || 'text-black'
    return (
        <h2
            className={`font-bold text-2xl md:text-[40px] md:leading-12 ${color} ${textAlignment}`}>
            {children}
        </h2>
    )
}

export default SectionHeading
